import React from "react";
import SignInLayer from "../components/SignInLayer";

const Login = () => {
  return (
    <>
      {/* SignInLayer */}
      <SignInLayer />
    </>
  );
};

export default Login;
